/** Full notifications page path for the signed-in role. */
export function notificationsPagePath(role) {
  const r = String(role || "").trim();
  if (r === "hiring-manager" || r === "recruiter") {
    return "/hiring/notifications";
  }
  return "/applicant/notifications";
}
